import { useEffect, useState } from "react";
import { getSearchedDestinations } from "@/lib/searched-destinations.functions";

// Cache modułowy: jednorazowo per miasto na żywotność karty przeglądarki.
const cache = new Map<string, string[]>();
const inflight = new Map<string, Promise<string[]>>();

async function fetchSearched(city: string): Promise<string[]> {
  if (cache.has(city)) return cache.get(city)!;
  const existing = inflight.get(city);
  if (existing) return existing;
  const p = (async () => {
    try {
      const res = await getSearchedDestinations({ data: { city } });
      const codes = res?.codes ?? [];
      cache.set(city, codes);
      return codes;
    } catch {
      cache.set(city, []);
      return [];
    } finally {
      inflight.delete(city);
    }
  })();
  inflight.set(city, p);
  return p;
}

/**
 * Top kierunki najczęściej WYSZUKIWANE z danego miasta (sygnał popytu z
 * tabeli `search_queries`). Trafia z wysokim priorytetem do podpowiedzi
 * w pickerze "Dokąd", obok rankingu z `city_top_destinations`.
 */
export function useSearchedDestinations(cityCode: string | undefined): string[] {
  const code = cityCode?.toUpperCase() ?? "";
  const [codes, setCodes] = useState<string[]>(() => (code ? cache.get(code) ?? [] : []));
  useEffect(() => {
    if (!code) {
      setCodes([]);
      return;
    }
    setCodes(cache.get(code) ?? []);
    let cancelled = false;
    fetchSearched(code).then((c) => {
      if (!cancelled) setCodes(c);
    });
    return () => {
      cancelled = true;
    };
  }, [code]);
  return codes;
}
